import { copyToClipboard } from '@/utils/misc/clipboard'

async function clipboardClickHandler(event) {
  const { el, func, label, allowEvent } = this
  let { text } = this
  if (!allowEvent) {
    event.stopPropagation()
    event.preventDefault()
  }

  // Get the text to copy and copy it to the clipboard.
  if (func) {
    const fresult = func()
    if (fresult?.then) {
      text = await Promise.resolve(fresult)
    } else {
      text = fresult
    }
  }
  copyToClipboard(el, text, label)
}

function install(el, binding, vnode) {
  // Get the promise binding.
  let text, func
  if (binding.arg === 'text' || typeof binding.arg === 'undefined') {
    text = binding.value
  } else if (binding.arg === 'function') {
    func = binding.value
  }

  // Get optional label.
  const label = el.getAttribute('clipboardLabel') || el.getAttribute('clipboard-label')

  // Get optional event flag.
  const allowEventValue = el.getAttribute('allowEvent') || el.getAttribute('allow-event');
  const allowEvent = allowEventValue !== false && allowEventValue !== 'false'

  if (el.__clipboard_listener) {
    el.removeEventListener('click', el.__clipboard_listener)
  }
  el.addEventListener('click', (el.__clipboard_listener = clipboardClickHandler.bind({ el, text, func, label, allowEvent })))
}

export default function(app) {
  app.directive('yb-clipboard', {
    beforeMount: install,
    updated: install,
    unmounted(el) {
      el.removeEventListener('click', el.__clipboard_listener)
      delete el.__clipboard_listener
    }
  })
}
